/**
 * Logs an error to the Nuxt server.
 * @param {Error} error - The error object to log.
 * @param {string} info - Additional information about the error context.
 * @param {object} [user] - Optional user details to include in the log.
 */
export async function useServerLogger(
  error: Error,
  info: string,
  user?: Record<string, any>,
) {
  try {
    const endpoint = "/api/log-error";

    await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        error: error.message || error.name || "Unknown error",
        stack: error.stack || "No stack trace available",
        info,
        user,
      }),
    });
  } catch (loggingError) {
    // eslint-disable-next-line no-console
    console.error(
      "[useServerLogger] Failed to log error to server:",
      loggingError,
    );
  }
}
